import DefaultCell from './DefaultCell';

export default DefaultCell;
